@if (dTypeForm) {
  <div class="flex flex-col w-full h-full">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
      <div class="text-lg font-medium">{{ data.privilege.displayName }}</div>
      <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
        <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
      </button>
    </div>
    <!-- Content -->
    <div class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>
      <dtype-component-list [dtypeForm]="dTypeForm">
      </dtype-component-list>
      @if (!data.readonly) {
        <div class="flex justify-end">
          <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
            {{ 'cancel' | transloco }}
          </button>
          <button class="mr-2" mat-raised-button color="accent" (click)="reset()">
            {{ 'resetPermissions' | transloco }}
          </button>
          <button class="mr-2" mat-raised-button color="primary" (click)="accept()">
            {{ 'accept' | transloco }}
          </button>
        </div>
      }
    </div>
  </div>
}